import {WinPresentationBasicState} from '@fantasmagames/slot/src/modules/winpresentation/states/WinPresentationBasicState';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';
import {Timer} from '@fantasmagames/core/src/update/Timer';
import {Logic} from '@fantasmagames/slot/src/logic/Logic';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {GameFlowEvents} from 'src/flow/GameFlowEvents';
import {GameWinPresentationModule} from 'src/winpresentation/GameWinPresentationModule';

export class GameWinPresentationBasicState extends WinPresentationBasicState {

	protected setupEvents(): void {
		super.setupEvents();

		this.on(GameFlowEvents.HAS_WIN_WITH_MULTIPLIER, this.onHasWinWithMultiplier);
		this.on(GameFlowEvents.HAS_BIGWIN_WITH_MULTIPLIER, this.onHasBigWinWithMultiplier);
		this.on(GameFlowEvents.HAS_WIN_WITH_NO_MULTIPLIER, this.onHasWinWithNoMultiplier);
	}

	protected onWon(): void {

	}

	protected onHasWinWithMultiplier(): void {
		this.module.gotoState(GameWinPresentationModule.WIN_WITH_MULTIPLIER_STATE);
	}

	protected onHasWinWithNoMultiplier(): void {
		this.module.gotoState(GameWinPresentationModule.WIN_NO_MULTIPLIER_STATE);
	}

	protected onHasBigWinWithMultiplier(): void {
		this.module.gotoState(GameWinPresentationModule.BIG_WIN_WITH_MULTILPLER_STATE);
	}
}



// WEBPACK FOOTER //
// ./src/winpresentation/states/GameWinPresentationBasicState.ts